import { client } from '../http';

export default {
  async reportSuspiciousGroupJoin() {
    return await client.post('/api/investigator/suspicious-group-join');
  },
};
